module.exports = __webpack_public_path__ + "img/new_15.3d445074.jpg";